import { trackEvent } from "@/modules/shared/utils/mixpanel";
import { captureEvent } from "@/modules/shared/utils/posthog";

// Dual-tracks to Mixpanel and PostHog, mirroring Caladan's pattern.
export function trackBookingEvent(
  eventName: string,
  properties?: Record<string, unknown>,
): void {
  trackEvent(eventName, properties);
  captureEvent(eventName, properties);
}
